export default {
	"CouponItem.full": "满",
	"CouponItem.available": "可用",
	"CouponItem.PickUpAgain": "再次领取",
	"CouponItem.ClaimItNow": "立即领取",
	"CouponItem.Details": "详细信息"
}